import {Injectable} from '@angular/core';

import {Globals} from './globals';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ClientUserData} from '../models/client-user-data';
import {environment} from '../../../environments/environment';
import {DataLayerService} from "./data-layer.service";

@Injectable()
export class TrackingService {
  private trackingUrl = 'https://listings.caymanmarshalladmin.com/api/v1/client-user-journey'; // URL to web api


  constructor(
    private http: HttpClient,
    private globals: Globals,
    protected dataLayerService: DataLayerService) {

  }

  public trackUserJourney(listingId: number, action: string, actionDetails: string): Observable<ClientUserData> | object {
    // console.log(this.globals);


    const paramsObj = this.setupTrackingObject(listingId, action, actionDetails);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + environment.apiKey
      }),
    };
    return this.http.post<ClientUserData | object>(this.trackingUrl, paramsObj.toString(), httpOptions).subscribe((response) => {
      console.log(response);
    });
  }

  public setupTrackingObject(listingId: number, action: string, actionDetails: string): HttpParams {
    const jsonObj = {
      listing_id: listingId ?? null,
      client_user_id: this.globals.clientId ?? null,
      action: action ?? null,
      action_details: actionDetails ?? null,
      session_id: this.globals.sidStr ?? null
    }
    if (!listingId) {
      delete (jsonObj as any)['listing_id'];
    }
    if (!this.globals.clientId) {
      //console.log(this.globals.clientId);
      delete (jsonObj as any)['client_user_id'];
    }
    if (!action) {
      delete (jsonObj as any)['action'];
    }
    if (!actionDetails) {
      delete (jsonObj as any)['action_details'];
    }
    if (!this.globals.sidStr) {
      delete (jsonObj as any)['session_id'];
    }
    const paramObj = new HttpParams({
      fromObject: jsonObj
    });
    return paramObj;
  }

  protected trackAnalyticsEvent(obj: {
    _catStr: any;
    _eventStr: any;
    _labelStr: any;
  }) {
    // console.log('trackAnalyticsEvent');
    // console.log(obj._eventStr);
    // define properties
    const catStr = obj._catStr;
    const eventStr = obj._eventStr;
    const labelStr = obj._labelStr;
    let actionStr = 'Search Parameter Change';
    // fork, if this is a preview  then set the event action accordingly
    if (eventStr === 'preview') {
      actionStr = 'Preview Listing';
    }
    try {
      this.dataLayerService.logEvent(
        eventStr,
        catStr,
        actionStr,
        labelStr,
      );
      /*
      ga('send', {
        hitType: 'event',
        eventCategory: catStr,
        eventAction: actionStr,
        eventLabel: labelStr,
        'hitCallback' : function () {
          //alert("Event received");
        }
      });*/
    } catch (e) {
      console.log(e);
      console.log('ANALYTICS DISABLED');
    }
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
